import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL

class PaymentMethodService {

  create(mid, paymentMethod) {
    return http.post(API_URL + `/merchants/${mid}/v1/payment-methods`, paymentMethod, { headers: authHeader() });
  }

  update(mid, id, paymentMethod) {
    return http.put(API_URL + `/merchants/${mid}/v1/payment-methods/${id}`, paymentMethod, { headers: authHeader() });
  }

  delete(mid, id) {
    return http.delete(API_URL + `/merchants/${mid}/v1/payment-methods/${id}`, { headers: authHeader() });
  }

  find(mid, params) {
    return http.get(API_URL + `/merchants/${mid}/v1/payment-methods`, { params: params, headers: authHeader() });
  }

  findById(mid, id) {
    return http.get(API_URL + `/merchants/${mid}/v1/payment-methods/${id}`, { headers: authHeader() });
  }

  handleResponse(response) {
    return response
  }
}

export default new PaymentMethodService();



// WEBPACK FOOTER //
// ./src/service/payment.method.service.js